// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch-session-dialog-content {
  display: flex;
  flex-direction: row;
  gap: var(--dialog-element-gap);
  justify-content: space-evenly;
  align-items: center;

  > .session-select {
    flex-grow: 1;
  }
}

.switch-session-dialog-participants {
  margin-right: var(--dialog-padding);
  overflow: hidden;
}

.switch-session-dialog-participants span {
  font-size: var(--font-size-l);
  white-space: normal;
}

.switch-session-dialog-separator {
  height: var(--input-element-height-large);
  width: 1px;
  max-width: 1px;
  min-width: 1px;
  background-color: var(--text-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui/dialogs/switch-session-dialog/SwitchSessionDialog.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;;EAEnB;IACE,YAAY;EACd;AACF;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,UAAU;EACV,cAAc;EACd,cAAc;EACd,mCAAmC;AACrC","sourcesContent":[".switch-session-dialog-content {\n  display: flex;\n  flex-direction: row;\n  gap: var(--dialog-element-gap);\n  justify-content: space-evenly;\n  align-items: center;\n\n  > .session-select {\n    flex-grow: 1;\n  }\n}\n\n.switch-session-dialog-participants {\n  margin-right: var(--dialog-padding);\n  overflow: hidden;\n}\n\n.switch-session-dialog-participants span {\n  font-size: var(--font-size-l);\n  white-space: normal;\n}\n\n.switch-session-dialog-separator {\n  height: var(--input-element-height-large);\n  width: 1px;\n  max-width: 1px;\n  min-width: 1px;\n  background-color: var(--text-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
